// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__X02md","spinner":"Loader_spinner__iDFIv"};